<template>
    <div :class="ui.root()">
        <Icon v-if="name" :name="name" :class="ui.icon()" />
    </div>
</template>

<script setup lang="ts">
    import {
        SidebarNavIconVariants,
        type SidebarNavIconVariant
    } from '@/assets/css/themes/custom-components/constants/sidebar-nav-icon';

    const props = defineProps({
        name: {
            type: String,
            default: ''
        },
        active: {
            type: Boolean
        },
        variant: {
            type: String as PropType<SidebarNavIconVariant>,
            default: SidebarNavIconVariants.Base
        }
    });

    const ui = useComponentUi('sidebarNavIcon', () => ({
        variant: props.variant,
        active: props.active
    }));
</script>
